import { Component, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TimerService } from './timer.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-timer',
    templateUrl: './timer.component.html'
})

export class TimerComponent {
    @Output() close: EventEmitter<boolean> = new EventEmitter();
    @Input() timerService: TimerService;
    @ViewChild('modalInactivity') modalInactivity: ElementRef;

    public subscription: Subscription = new Subscription();

    constructor(
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
        this.subscription = this.timerService.inactivity.subscribe(() => {
            // Overlay propio: 'backdrop-inactivity' pinta el fondo oscurecido y
            // 'window-inactivity' eleva el z-index del diálogo por encima del #view
            // para que quede visible sobre el overlay. Ambas clases son exclusivas de
            // este modal, así que no afectan a las demás vistas ni modales.
            const options: NgbModalOptions = {
                backdropClass: 'backdrop-inactivity',
                windowClass: 'window-inactivity'
            };
            this.modalService.open(this.modalInactivity, options);
        });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    modalClose(): void {
        this.close.emit(true);
        this.modalService.dismissAll();
    }
}
